export type NullablePartial<T> = { [P in keyof T]?: T[P] | null };
export type Nullable<T> = { [P in keyof T]: T[P] | null };
